import { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import PageContainer from "../components/pages-parts/PageContainer";
import ContactForm from "../components/pages-parts/ContactForm";
const Contact = () => {
  const [state] = useState({
    heading: "contact us",
    pageHeading: "leave your message in the contact form",
    message:
      "No. 7, Love Estate, Road 2, Gbelu Adekola Adegbuyi Street, Lagos State, Nigeria.",
  });
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Helmet>
        <title>Contact page</title>
        <meta name="description" content="travel friends contact page" />
      </Helmet>
      <PageContainer data={state}>
        <ContactForm />
      </PageContainer>
    </>
  );
};
export default Contact;
